module.exports = __webpack_public_path__ + "img/app4.e0314e41.png";